import { Checkbox, Collapse } from 'antd';
import { TemplateConfig } from '../../../Templar/RenderPdfPrescription';
import { AntTooltip } from '../../../components/common/AntTooltip';
const { Panel } = Collapse;

const Advices: React.FC<{
    rxConfig: TemplateConfig | undefined;
    saveRxConfigInState: (rxObj: TemplateConfig) => void;
    sectionName?: string;
}> = ({ rxConfig, saveRxConfigInState, sectionName }) => {
    return (
        <Collapse
            expandIcon={() => (
                <div className="rounded-4 min-w-26 h-26 flex items-center justify-center bg-darwin-accent-mauve-800">
                    <div className="w-full h-full flex items-center justify-center">
                        <svg
                            className="w-12 h-12 fill-white"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 13 12"
                        >
                            <path d="M11.4766 0H2.47656C1.63281 0 0.976562 0.679688 0.976562 1.5V8.22656C0.976562 9.04688 1.63281 9.70312 2.47656 9.70312H4.72656V11.6484C4.72656 11.7422 4.77344 11.8594 4.86719 11.9062C4.96094 11.9531 5.07812 11.9297 5.17188 11.8828L8.10156 9.67969H11.4766C12.2969 9.67969 12.9766 9 12.9766 8.20312V1.5C12.9766 0.679688 12.3203 0 11.4766 0ZM9.625 5.48438C9.625 5.69531 9.4375 5.85938 9.25 5.85938H7.98438V7.125C7.98438 7.33594 7.79688 7.5 7.60938 7.5H6.39062C6.17969 7.5 6.01562 7.33594 6.01562 7.125V5.85938H4.75C4.53906 5.85938 4.375 5.69531 4.375 5.48438V4.26562C4.375 4.07812 4.53906 3.89062 4.75 3.89062H5.99219V2.625C5.99219 2.4375 6.15625 2.25 6.36719 2.25H7.58594C7.77344 2.25 7.96094 2.4375 7.96094 2.625V3.89062H9.25C9.4375 3.89062 9.625 4.07812 9.625 4.26562V5.48438Z"></path>
                        </svg>
                    </div>
                </div>
            )}
        >
            <Panel header={<div className="font-700">{sectionName || 'Advices'}</div>} key="1">
                <p className="mr-16 space-y-2">
                    <div className="cursor-pointer">
                        <p
                            className="cursor-pointer flex flex-1 items-center justify-between"
                            onClick={() => {
                                saveRxConfigInState({
                                    advices_format:
                                        rxConfig?.advices_format === 'pipe-seperated'
                                            ? ''
                                            : 'pipe-seperated',
                                });
                            }}
                        >
                            <span>Use bullet points</span>
                            <Checkbox checked={!rxConfig?.advices_format}></Checkbox>
                        </p>
                    </div>
                    <div className="border-b border-darwin-neutral-200 mx-8"></div>
                    <div className="flex items-center justify-between">
                        <div>Heading</div>{' '}
                        <div className="flex space-x-12">
                            <input
                                type="color"
                                id="head"
                                name="head"
                                value={rxConfig?.advices_heading_color || '#2188FF'}
                                onChange={(e) => {
                                    saveRxConfigInState({
                                        advices_heading_color: e.target.value,
                                    });
                                }}
                                className="circular-color-input"
                            />

                            <AntTooltip content="Reset">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 512 512"
                                    className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                    onClick={() => {
                                        saveRxConfigInState({
                                            advices_heading_color: '',
                                        });
                                    }}
                                >
                                    <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                </svg>
                            </AntTooltip>
                        </div>
                    </div>
                    <div className="flex items-center justify-between">
                        <div>Properties</div>{' '}
                        <div className="flex space-x-12">
                            <input
                                type="color"
                                id="head"
                                name="head"
                                value={rxConfig?.advices_properties_color || '#000000'}
                                onChange={(e) => {
                                    saveRxConfigInState({
                                        advices_properties_color: e.target.value,
                                    });
                                }}
                                className="circular-color-input"
                            />

                            <AntTooltip content="Reset">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 512 512"
                                    className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                    onClick={() => {
                                        saveRxConfigInState({
                                            advices_properties_color: '',
                                        });
                                    }}
                                >
                                    <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                </svg>
                            </AntTooltip>
                        </div>
                    </div>
                </p>
            </Panel>
        </Collapse>
    );
};

export default Advices;
